import { initialsOf } from './initialsOf';

import s from './UserAvatar.module.scss';

/** Кружок с инициалами, как в Яндекс Трекере: 20px в списках, 32px у комментариев */
const UserAvatar: React.FC<{ name: string; size?: number }> = ({ name, size = 20 }) => (
  <span
    className={s.avatar}
    style={{ width: size, height: size, fontSize: Math.round(size * 0.42) }}
    aria-hidden
  >
    {initialsOf(name)}
  </span>
);

export { UserAvatar };
